<template>
  <b-navbar ref="bottomHeader" id="bottom-header" fixed="top" toggleable="md" type="primary">
    <b-container>

      <b-navbar-toggle target="nav-collapse" variant="primary">
        <template #default="{ expanded }">
          <i v-if="expanded" class="fa fa-close text-primary"></i>
          <i v-else class="fa fa-bars text-primary"></i>
        </template>
      </b-navbar-toggle>

      <b-navbar-brand class="mx-auto d-md-none" href="#">
        <img :src="$getConst.images.logo_default" height="40" alt="Hays logo">
      </b-navbar-brand>
      <ProfileDropdown v-if="isMobileView"/>
      <b-collapse id="nav-collapse" is-nav>
        <template v-if="$store.getters['auth/isAuthenticated']">
          <template v-for="item in this.$getConst.menu">
            <b-navbar-nav class="w-100 justify-content-center" v-if="(item.roles && hasRole(item.roles)) || !item.roles">
              <template v-if="!item.children">
                <b-nav-item @click="$router.push({name: item.url})">
                  <AppSvgIcon :icon="item.icon" height="30"></AppSvgIcon>
                  <span class="nav-menu">{{$t(item.name)}}</span>
                </b-nav-item>
              </template>
              <b-nav-item v-else>
                <AppGridDropdown
                  :button-icon="item.icon"
                  :button-text="item.name"
                  :items="item.children"
                />
              </b-nav-item>
            </b-navbar-nav>
          </template>
        </template>

      </b-collapse>

    </b-container>
  </b-navbar>
</template>

<script>
  import ProfileDropdown from "./ProfileDropdown";
  import AppGridDropdown from "../../common/utils/AppGridDropdown";

  export default {
    name: "BottomHeader",
    components: {AppGridDropdown, ProfileDropdown},
    props: {
      isMobileView: {
        type: Boolean,
        default: false
      },
    }
  }
</script>

<style scoped>

</style>
